import { Box } from '@abyss/web/ui/Box';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import find from 'lodash/find';

import { ConstantsLagoon } from '../../../../../../common/ConstantsLagoon';
import {
  SmartChoiceScoreBox,
  SmartChoiceScorePrintView,
} from '../../../../../../common/SnackCard/SnackCard.styles';
import { useLagoon } from '../../../../../../hooks/useLagoon';
import { useSmartChoice } from '../../../../../../hooks/useSmartChoice';
import { ProviderType } from '../../../../../../models/ProviderDetails';
import {
  getNameAttrs,
  parseProviderName,
} from '../../../../../../utils/providerNames.utils';
import {
  LayoutGroupStyled,
  ProviderNameWithScore,
} from '../../../CompareSmartChoice/CompareSmartChoice.styled';
import { isAttributeChecked } from '../../../CompareSmartChoice/utils';
import {
  PrintViewDivider,
  PrintViewProviderDetailsXSText,
  PrintViewProviderMediumText,
  Section,
} from './PrintExpandedCardStyle.styled';

export const PrintExpandedGeneralCard = ({
  selectedAttributes,
  selectedProviders,
}) => {
  const isSmartChoice = useSmartChoice();

  const lagoonData = useLagoon('ui-messaging')();
  const no_specialty = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.COMPARE.COMPARE_SPECIALTY_NOT_AVAILABLE,
  })?.message;
  const pcp_available = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.COMPARE.COMPARE_PCP_SERVICES_AVAILABLE,
  })?.message;
  const pcp_not_available = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.COMPARE
      .COMPARE_PCP_SERVICES_NOT_AVAILABLE,
  })?.message;

  return (
    <Section>
      <LayoutGroupStyled css={{ '& > div': { width: '100%' } }} grow>
        {selectedProviders?.map((item, index) => (
          <Box
            color="$white"
            css={{
              padding: '4px',
              border: '1px solid rgba(229, 229, 230, 1)',
              boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.05)',
            }}
            key={index}
          >
            <LayoutGroupStyled className="icon-name-container">
              <ProviderNameWithScore>
                <PrintViewProviderMediumText
                  css={{
                    fontFamily: 'UHC2020 Sans',
                    fontWeight: '600',
                    fontSize: '18px',
                    lineHeight: '24px',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                    color: '#4B4D4F',
                  }}
                >
                  {parseProviderName(
                    item?.providerName,
                    ProviderType.PRACTITIONER,
                    item?.primaryDegrees?.[0],
                    getNameAttrs(item)
                  )}
                </PrintViewProviderMediumText>
                {isSmartChoice && (
                  <SmartChoiceScoreBox>
                    <SmartChoiceScorePrintView>
                      {`Smart Choice ${
                        item?.recommendationDetails?.totalRecommendationScore ||
                        0
                      }%`}
                    </SmartChoiceScorePrintView>
                  </SmartChoiceScoreBox>
                )}
              </ProviderNameWithScore>
            </LayoutGroupStyled>
          </Box>
        ))}
      </LayoutGroupStyled>

      {selectedAttributes?.find((record) => record.name === 'specialties')
        ?.isChecked && (
        <>
          <LayoutGroupStyled css={{ '& > div': { width: '100%' } }} grow>
            {selectedProviders?.map((item, index) => (
              <LayoutGroupStyled css={{ alignItems: 'center' }} key={index}>
                <PrintViewProviderDetailsXSText>
                  {item?.speciality !== '' ? item?.speciality : no_specialty}
                </PrintViewProviderDetailsXSText>
              </LayoutGroupStyled>
            ))}
          </LayoutGroupStyled>
          {isAttributeChecked(selectedAttributes, [
            'hasPCPServiceAvailability',
          ]) && (
            <LayoutGroupStyled
              css={{ '& > div': { width: '100%' } }}
              cssProps={{ minHeightAuto: true }}
              grow
            >
              {selectedProviders?.map((_, index) => (
                <PrintViewDivider key={index} orientation="horizontal" />
              ))}
            </LayoutGroupStyled>
          )}
        </>
      )}

      {/* PREMIUM CARE PROVIDER */}
      {selectedAttributes.find(
        (record) => record.name === 'hasPCPServiceAvailability'
      )?.isChecked && (
        <LayoutGroupStyled css={{ '& > div': { width: '100%' } }} grow>
          {selectedProviders?.map((item, index) => (
            <LayoutGroupStyled css={{ alignItems: 'center' }} key={index}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {item?.hasPCPServiceAvailability && (
                  <IconSymbol color="#007000" icon="done" size="20px" />
                )}
                <PrintViewProviderDetailsXSText
                  css={{
                    marginTop: item?.hasPCPServiceAvailability ? '0px' : '6px',
                  }}
                >
                  {item?.hasPCPServiceAvailability
                    ? pcp_available
                    : pcp_not_available}
                </PrintViewProviderDetailsXSText>
              </div>
            </LayoutGroupStyled>
          ))}
        </LayoutGroupStyled>
      )}
    </Section>
  );
};
